import React from "react";
import twitter from "../../../assets/images/twitter.svg";
import linkedin from "../../../assets/images/linkedin.svg";
import behance from "../../../assets/images/behance.svg";
import instagram from "../../../assets/images/instagram.svg";
import Flex from "../ui/Flex/Flex";
import "./index.scss";

const Footer = (): JSX.Element => {
  return (
    <div className="footer">
      <div className="section-wrapper">
        <Flex justifyBetween alignCenter fullHeight minHeight="170px">
          <div className="footer_contact">
            <Flex column gap={2}>
              <span className="font-weight-5">Contact</span>
              <a className="text-small" href="mailto:tedui.design@gmail.com">
                tedui.design@gmail.com
              </a>
            </Flex>
          </div>
          <div className="footer_thanks">
            <span className="font-weight-6 text-title-4">
              Merci d'avoir visité mon portfolio
            </span>
          </div>
          <div className="footer_social">
            <Flex gap={4}>
              <div className="social">
                <a href="www.google.com">
                  <img src={twitter} alt="Icone twitter" />
                </a>
              </div>
              <div className="social">
                <a href="www.google.com">
                  <img src={behance} alt="Icone behance" />
                </a>
              </div>
              <div className="social">
                <a href="www.google.com">
                  <img src={linkedin} alt="Icone linkedin" />
                </a>
              </div>
              <div className="social">
                <a href="www.google.com">
                  <img src={instagram} alt="Icone instagram" />
                </a>
              </div>
            </Flex>
          </div>
        </Flex>
        <div className="footer_bg"></div>
      </div>
    </div>
  );
};

export default Footer;
